import axios from 'axios';

import { REACT_APP_RELEASE_STAGE } from '@/common/environment';
import { isSSOLoginTenant } from '@/common/Tenants';
import { SystemEnvironment } from '@/constants/systemEnviroment';
import {
  SYSTEM_ENVIRONMENT_HEADER,
  SYSTEM_RELEASE_STAGE_HEADER,
} from '@/lib/PlannerService';

export interface HttpPromise
  extends Promise<{
    data: any;
    headers: any;
    status: number;
  }> {}

/** Axios library wrapper, required for ajax calls */
export class DefaultHttpService {
  axios: any;

  constructor() {
    this.axios = axios.create({});
  }

  /**
   * Sets the global authorization token.
   *
   * @param token
   */
  authorization(token: string): void {
    if (isSSOLoginTenant()) {
      this.axios.defaults.headers['Authorization'] = token;
    } else {
      this.axios.defaults.headers['Authorization'] = `Bearer ${token}`;
    }
  }

  get(url: string, env?: SystemEnvironment): HttpPromise {
    const headers: Record<string, string> = {};
    if (env) {
      headers[SYSTEM_ENVIRONMENT_HEADER] = env;
    }
    if (REACT_APP_RELEASE_STAGE) {
      headers[SYSTEM_RELEASE_STAGE_HEADER] = REACT_APP_RELEASE_STAGE;
    }

    return this.axios.get(url, { headers }) as HttpPromise;
  }

  post(url: string, data?: any): HttpPromise {
    return this.axios.post(url, data) as HttpPromise;
  }

  put(url: string, data?: any): HttpPromise {
    return this.axios.put(url, data) as HttpPromise;
  }

  delete(url: string, data?: any): HttpPromise {
    return this.axios.delete(url, data) as HttpPromise;
  }

  addInterceptor(
    onFulfilled?: (value: any) => any | Promise<any>,
    onRejected?: (error: any) => any,
  ): number {
    return this.axios.interceptors.response.use(onFulfilled, onRejected);
  }

  addRequestInterceptor(
    onFulfilled?: (value: any) => any | Promise<any>,
    onRejected?: (error: any) => any,
  ): number {
    return this.axios.interceptors.request.use(onFulfilled, onRejected);
  }

  removeRequestInterceptor(interceptorID: number): void {
    this.axios.interceptors.request.eject(interceptorID);
  }
}
